<template>
	<div>
		<el-drawer :visible.sync="isshow" :with-header="false" :before-close="handleClose" :modal="true"
			:wrapperClosable="false" :append-to-body="true">
			<div class="createdrawer_box" v-loading="loading">
				<div class="createdrawer_body">
					<div class="form-wrap">
						<div class="form">
							<div class="form__header">
								<div>
									<span class="text-bold">{{ title }}</span>
								</div>
								<div class="header_btn">
									<el-button class="closedrawerbtn" type="text" icon="el-icon-close"
										@click="handleClose"></el-button>
								</div>
							</div>


							<div class="form_field">
								<div class="form_left">
									<div v-for="(item, index) in classlist" style="margin-bottom: 23px"
										v-if="fieldlist.some(v => v.type == item.type)">
										<label class="tit_left"><i class="el-icon-collection-tag" style="
											  font-size: 12px;
											  color: #2b75ebff;
											  margin-right: 8px;
											"></i>{{ item.name || "" }}</label>
										<div class="form_item_left">
											<template v-for="value in fieldlist"
												v-if="value.type == item.type && value.is_show">
												<div class="items" v-if="value.field_type === 1">
													<label class="tit">{{ value.field }}<i v-if="value.required == 1"
															style="color: red">*</i></label>
													<el-input clearable :maxlength="value.maxLength"
														:disabled="value.disabled" v-model="value.content"
														:placeholder="value.placeholder" :class="value.length === 1 ? 'input_w230' : value.length === 0 ? 'input_w460' : value.length === 2
																? 'input_w690'
																: value.length === 3
																	? 'input_w920'
																	: 'input_w460'
															">
													</el-input>
												</div>
												<div class="items" :class="{ 'isdescribe': value.isdescribe }"
													v-else-if="value.field_type === 2">
													<label class="tit">{{ value.field }}<i v-if="value.required == 1"
															style="color: red">*</i></label>
													<el-input clearable :maxlength="value.maxLength"
														:disabled="value.disabled" type="textarea" :rows="1"
														v-model="value.content" :placeholder="value.placeholder" :class="value.length === 1 ? 'input_w230' : value.length === 0 ? 'input_w460'
																: value.length === 2
																	? 'input_w690'
																	: value.length === 3
																		? 'input_w920'
																		: 'input_w460'
															" style="height: auto">
													</el-input>
												</div>
												<div class="items" v-else-if="value.field_type === 3">
													<label class="tit">{{ value.field }}<i v-if="value.required == 1"
															style="color: red">*</i></label>
													<el-date-picker v-model="value.content" :disabled="value.disabled"
														value-format="timestamp" type="datetime"
														:placeholder="value.placeholder" :class="value.length === 1
															? 'input_w230'
															: value.length === 0
																? 'input_w460'
																: value.length === 2
																	? 'input_w690'
																	: value.length === 3
																		? 'input_w920'
																		: 'input_w460'">
													</el-date-picker>
												</div>
												<div class="items" v-else-if="value.field_type === 4">
													<label class="tit">{{ value.field }}<i v-if="value.required == 1"
															style="color: red">*</i></label>
													<el-input clearable :maxlength="value.maxLength"
														:disabled="value.disabled" v-model="value.content"
														:placeholder="value.placeholder" :class="value.length === 1
																? 'input_w230'
																: value.length === 0
																	? 'input_w460'
																	: value.length === 2
																		? 'input_w690'
																		: value.length === 3
																			? 'input_w920'
																			: 'input_w460'
															" oninput="value=value.replace(/[^0-9.]/g,'')">
													</el-input>
												</div>
												<div class="items" v-else-if="value.field_type === 18">
													<label class="tit">{{ value.field }}<i v-if="value.required == 1"
															style="color: red">*</i></label>
													<template>
														<el-select v-model="value.content" :disabled="value.disabled"
															:placeholder="value.placeholder" :class="value.length === 1
																	? 'input_w230'
																	: value.length === 0
																		? 'input_w460'
																		: value.length === 2
																			? 'input_w690'
																			: value.length === 3
																				? 'input_w920'
																				: 'input_w460'
																" @change="handleSwitch(value.content)">
															<el-option v-for="(item2, index2) in value.field_list"
																:key="item2.form_id" :label="item2.name"
																:value="item2.form_id">
															</el-option>
														</el-select>
													</template>

												</div>

												<div class="items" v-else-if="value.field_type === 5">
													<label class="tit">{{ value.field }}<i v-if="value.required == 1"
															style="color: red">*</i></label>

													<template>
														<el-select v-model="value.content" :disabled="value.disabled"
															:placeholder="value.placeholder" :class="value.length === 1
																	? 'input_w230'
																	: value.length === 0
																		? 'input_w460'
																		: value.length === 2
																			? 'input_w690'
																			: value.length === 3
																				? 'input_w920'
																				: 'input_w460'
																">
															<el-option v-for="(item2, index2) in value.field_list"
																:key="item2.id" :label="item2.name" :value="item2.id">
															</el-option>
														</el-select>
													</template>
												</div>

												<div class="items" v-else-if="value.field_type === 6">
													<label class="tit">{{ value.field }}<i v-if="value.required == 1"
															style="color: red">*</i></label>
													<!-- el-select collapse-tags -->
													<el-select multiple v-model="value.content" :disabled="value.disabled"
														:placeholder="value.placeholder" :class="value.length === 1
																? 'input_w230'
																: value.length === 0
																	? 'input_w460'
																	: value.length === 2
																		? 'input_w690'
																		: value.length === 3
																			? 'input_w920'
																			: 'input_w460'
															">
														<el-option v-for="(item2, index2) in value.field_list"
															:key="item2.id" :label="item2.name" :value="item2.id">
														</el-option>
													</el-select>
												</div>
												<!-- 附件 -->
												<div class="items" :class="value.length === 1
														? 'input_w230'
														: value.length === 0
															? 'input_w460'
															: value.length === 2
																? 'input_w690'
																: value.length === 3
																	? 'input_w920'
																	: 'input_w460'
													" v-else-if="value.field_type === 7">
													<label class="tit">{{ value.field }}
														<i v-if="value.required == 1" style="color: red">*</i>
													</label>

													<enclofile :ref="'clofile' + value.id" :disabled="value.disabled"
														:enclist="value.content" :fieldid="value.id"
														:filenum="value.field_list ? value.field_list.fileNum : 10"
														:filesize="value.field_list ? value.field_list.filesize : 10"
														@setupfile="setupfile">
													</enclofile>


												</div>
												<!-- 图片 -->
												<div class="items" :class="value.length === 1
														? 'input_w230'
														: value.length === 0
															? 'input_w460'
															: value.length === 2
																? 'input_w690'
																: value.length === 3
																	? 'input_w920'
																	: 'input_w460'
													" v-else-if="value.field_type === 8">
													<label class="tit">{{ value.field }}
														<i v-if="value.required == 1" style="color: red">*</i>
													</label>
													<enclofile :ref="'clofile' + value.id" :disabled="value.disabled"
														:enclist="value.content" :fieldid="value.id"
														:filenum="value.field_list ? value.field_list.imgNum : 1"
														@setupfile="setupfile" accept=".png,.jpg,.jpeg">
													</enclofile>

												</div>

												<!-- 客户选择 -->
												<div class="items" :class="value.length === 1
														? 'input_w230'
														: value.length === 0
															? 'input_w460'
															: value.length === 2
																? 'input_w690'
																: value.length === 3
																	? 'input_w920'
																	: 'input_w460'
													" v-else-if="value.field_type === 9">
													<label class="tit">{{ value.field }}
														<i v-if="value.required == 1" style="color: red">*</i>
													</label>
													<div :class="{ 'isdisabled': value.disabled }">
														<newgratedropdown :seltype="1" :class="value.length === 1
															? '230px'
															: value.length === 0
																? '460px'
																: value.length === 2
																	? '690px'
																	: value.length === 3
																		? '920px'
																		: '460px'" :singleval="value.singleval" :clearable="false" @outlet="fn_outlet($event, value.id)">
														</newgratedropdown>
													</div>
												</div>
												<!-- 客户关联 联系人  -->
												<div class="items" v-else-if="value.field_type == 10"
													:class="{ 'isdisabled': !value.field_list.length }">
													<label class="tit">{{ value.field }}<i v-if="value.required == 1"
															style="color: red">*</i></label>
													<template>
														<el-select v-model="value.content" :disabled="value.disabled"
															:placeholder="value.placeholder" :class="value.length === 1
																	? 'input_w230'
																	: value.length === 0
																		? 'input_w460'
																		: value.length === 2
																			? 'input_w690'
																			: value.length === 3
																				? 'input_w920'
																				: 'input_w460'
																">
															<el-option v-for="(item2, index2) in value.field_list"
																:key="item2.id" :label="item2.name" :value="item2.id">
															</el-option>
														</el-select>
													</template>
												</div>
												<!--  -->
												<!-- 关联选择 -->
												<div class="items" :class="value.length === 1
														? 'input_w230'
														: value.length === 0
															? 'input_w460'
															: value.length === 2
																? 'input_w690'
																: value.length === 3
																	? 'input_w920'
																	: 'input_w460'
													" v-else-if="value.field_type === 11">
													<label class="tit">{{ value.field }}
														<i v-if="value.required == 1" style="color: red">*</i>
													</label>
													<div :class="{ 'isdisabled': value.disabled }">
														<newgratedropdown :seltype="value.seltype" :class="value.length === 1
															? '230px'
															: value.length === 0
																? '460px'
																: value.length === 2
																	? '690px'
																	: value.length === 3
																		? '920px'
																		: '460px'" :singleval="value.singleval" :clearable="false" @outlet="fn_outlet($event, value.id)">
														</newgratedropdown>
													</div>

												</div>

												<!-- 富文本 -->
												<div class="items" v-else-if="value.field_type === 19">
													<label class="tit">
														{{ value.field }}
														<i v-if="value.required == 1" style="color: red">*</i>
													</label>
													<vue-ueditor-wrap v-model="value.content"
														:config="editorConfig"></vue-ueditor-wrap>
												</div>
												<!-- 联系人关联线索、客户 -->
												<div class="items" style="min-width: 900px;"
													:class="{ 'isdisabled': value.disabled }"
													v-else-if="value.field_type === 15">
													<div class="consactzs">
														<div class="tit">类型</div>
														<div>
															<el-radio v-if="value.cue_show" v-model="value.relation_type"
																:label="1" :disabled="value.cue_disabled">线索</el-radio>
															<el-radio v-if="value.customer_show"
																v-model="value.relation_type" :label="2"
																:disabled="value.customer_disabled">客户</el-radio>
														</div>
													</div>
													<div class="consactzs" v-show="value.relation_type == 1"
														v-if="value.cue_show">
														<div class="tit">关联线索</div>
														<newgratedropdown :seltype="11" :singleval="value.singleval1"
															:clearable="false" @outlet="fn_outlet($event, null, 1)">
														</newgratedropdown>
													</div>
													<div class="consactzs" v-show="value.relation_type == 2"
														v-if="value.customer_show">
														<div class="tit">关联客户:</div>
														<newgratedropdown :seltype="1" :singleval="value.singleval2"
															:clearable="false" @outlet="fn_outlet($event, null, 1)">
														</newgratedropdown>
													</div>
												</div>
												<!--  -->

												<!--  产品信息 -->
												<div v-else-if="value.field_type === 20">
													<!-- 产品 -->
													<addproduct ref="prodarea" :isnodata="false" :show="!loading"
														:disabled="value.disabled" :pro_list="value.content"
														:fieldid="value.id" @getlist="saveproduct"></addproduct>
													<!--  -->
												</div>
												<!--  -->


											</template>
										</div>
									</div>
								</div>
							</div>


							<!--  -->
							<div class="form_submit">
								<div class="form_submit_buttons1">
									<el-button @click="findfileArae(false)">保存</el-button>
								</div>
								<div class="form_submit_buttons2">
									<el-button style="width: 100px" @click="findfileArae(true)"
										v-if="savenew">保存并新建</el-button>
									<el-button style="width: 60px; margin-left: 8px" @click="handleClose">取消</el-button>
								</div>
							</div>
							<!--  -->


						</div>
					</div>
				</div>
			</div>
		</el-drawer>

	</div>
</template>

<script>
var that;
import VueUeditorWrap from "vue-ueditor-wrap";
import enclofile from "./enclofile.vue"
import addproduct from "./addproduct.vue"

import newgratedropdown from "@/components/integrated/newgratedropdown.vue";
import {
	JudgmentRequ,
	fn_retjson,
	retJSONArr,
} from "network/defaults";


import {
	lxrl_list_contact,
} from "network/hk_customer";
export default {
	name: "newbullet",
	components: {
		VueUeditorWrap,
		enclofile,
		addproduct,
		newgratedropdown,
	},
	props: {


		savenew: {
			type: Boolean,
			default: true,
		},


		//
		classlist: {
			type: Array,
			default: () => {
				return [];
			},
		},
		fieldlist: {
			type: Array,
			default: () => {
				return [];
			},
		},


		title: {
			type: String,
			default: "新建",
		},
		isshow: {
			type: Boolean,
			default: false,
		},


		// 基础数据 是否加载完成
		loading: {
			type: Boolean,
			default: true,
		},

	},

	data() {
		return {
			// 富文本配置
			editorConfig: {},
			uprefNum: 0,
			currentupNum: 0,
			saveFlag: false,

			uploading: null,

		};
	},
	created() {
		that = this;
		this.editorConfig = this.$store.state.UeditorConfig

	},

	watch: {
		isshow() {
			if (this.isshow) {
				this.setLxrdata()
			}
		},
		fieldlist() {
			if (this.isshow) {
				this.setLxrdata()
			}
		},
	},

	methods: {
		// 检查是否有客户字段,有客户需要获取联系人
		setLxrdata() {
			let index1 = this.findType(9)
			if (index1 != -1) {
				let id = this.fieldlist[index1] ? this.fieldlist[index1].content : '';
				if (id) {
					this.getlxrList(id)
				}
			}
		},
		// 获取 联系人  10
		getlxrList(customer_id) {
			if (!customer_id || typeof (customer_id) != 'number') return;
			let data = {
				page: 1,
				sort_type: 1,
				pagesize: 99, // 	是	int	每页数量
				customer_id,
			};
			lxrl_list_contact(data).then((res) => {
				if (res.code == 10000) {
					let arr = res.result.data || [];
					for (let item of arr) {
						item.id = item.contact_id
					}
					this.setassociat(arr, 10)
				}
			});
		},
		// 设置数据
		setassociat(arr, flag) {
			let index2 = this.findType(flag)
			if (arr.length) {

				this.fieldlist[index2].field_list = arr
				let content;
				if (flag == 10) { // 联系人
					content = arr[0].contact_id
				}
				let select_field = arr[0].name
				this.fieldlist[index2].content = content * 1
				this.fieldlist[index2].select_field = select_field
			}
		},
		// 动态下拉框选择
		fn_outlet(e, id, flag) {
			if (flag == 1) {  // 联系人关联线索、客户
				let index = this.findType(15)
				let curObj = this.fieldlist[index]
				if (e.seltype == 1) { // 客户
					curObj.customer_id = e.id
					curObj.customer_name = e.name
					curObj.cue_id = ''
					curObj.cue_name = ''
				}
				else if (e.seltype == 11) { // 线索
					curObj.cue_id = e.id
					curObj.cue_name = e.name
					curObj.customer_id = ''
					curObj.customer_name = ''
				}
			}
			else {
				let index = this.findIndex(id)
				this.fieldlist[index].content = e.id
				this.fieldlist[index].select_field = e.name
				if (e.seltype == 1) { // 客户
					// 联系人
					this.getlxrList(e.id)
				}
			}
		},
		findType(field_type) {
			let index = this.fieldlist.findIndex(v => v.field_type == field_type)
			if (index != -1 && this.fieldlist[index]) {
				return index
			} else {
				return -1
			}
		},
		findIndex(id) {
			let index = this.fieldlist.findIndex(v => v.id == id)
			if (index != -1 && this.fieldlist[index]) {
				return index
			}
		},

		// 弹出关闭
		handleClose() {
			this.$emit("update:isshow", false);
		},
		// 确定保存 按钮点击
		findfileArae(flag) {  // 
			if (!this.$clickgate()) return
			this.uploading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			this.saveFlag = flag
			this.judgefiles()
		},
		// 判断是否存在附件需要上传
		judgefiles() {
			let arr = this.fieldlist.filter(v => v.field_type == 7 || v.field_type == 8)
			if (arr.length) {
				let refsArr = []
				for (let item of arr) {
					let refname = `clofile${item.id}`
					refsArr.push(refname)
				}
				this.uprefNum = refsArr.length
				if (refsArr.length) {
					for (let item of refsArr) {
						if (this.$refs[item][0]) {
							this.$refs[item][0].flieChange()
						}
					}
				} else {
					this.judgeprod()
				}
			} else {
				this.judgeprod()
			}
		},
		setupfile(e) {

			console.log(e, 'setupfile')
			if (e && e.id) {
				let index = this.findIndex(e.id)
				this.fieldlist[index].content = e.list
				this.currentupNum += 1
				// 附件保存完毕 可以下一步
				if (this.currentupNum == this.uprefNum) {
					this.judgeprod()
				}
			}
		},
		// 判断是否存在产品需要保存 
		judgeprod() {
			let arr = this.fieldlist.filter(v => v.field_type == 20)
			if (arr.length) {
				if (this.$refs.prodarea[0]) {
					this.$refs.prodarea[0].fn_returnList()
				}
			} else {
				this.create_saveer()
			}
		},
		// 返回产品
		saveproduct(e) {
			if (e) {
				let index = this.findType(20)
				this.fieldlist[index].content = e.list || []
				this.create_saveer()
			}
		},
		//  新建 保存  确认
		create_saveer() {
			this.uploading.close();
			this.currentupNum = this.uprefNum = 0
			// 判断必填项是否填写
			let sflag1 = JudgmentRequ(this.fieldlist)
			if (!sflag1) return;
			let data = {
				fieldlist: JSON.stringify(this.fieldlist),
				flag: this.saveFlag,
			}
			this.$emit("saveer", data);

		},
		// 切换模板
		handleSwitch(formId) {
			this.$emit("fnswitch", formId);
		},




	},
};
</script>



<style scoped lang="scss">
@import "@/assets/css/fieldcreate.scss";


/deep/ .el-select__tags>span {
	display: block;
	width: 100%;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
</style>